.header-text {
    color: var(--grey-dk);
}
